import React, { memo } from 'react'

/**
 * QCMLABEL COMPONENT
 * @param {{ label: string }} props 
 * @returns {JSX.Element}
 */
function QCMLabel({label}) {
  return (
    <div>
      <h4 className='question'>{label}</h4>
      <p className='text-gray-500 text-xs'>Plusieurs réponses possibles.</p>
    </div>
  )
}

export default memo(QCMLabel)